import { InviteActions, InviteActionType } from '../actions/inviteActions';
import { Invite } from '../models/commonModels';

export type InviteState = {
    invite?: Invite;
};
const initialState: InviteState = {
    invite: undefined,
};

export default (state = initialState, action: InviteActions): InviteState => {
    switch (action.type) {
        case InviteActionType.GetInviteInfoSuccess:
            return {
                invite: action.payload,
            };
        default:
            return state;
    }
};
